import { Router } from "@angular/router";
import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { PageService } from "app/services/page-service";
import { environment } from "environments/environment";
import { ConfigurationService } from "app/modules/configuration/configuration.service";
import { RoleBasedAdminService } from "app/modules/role-based-admin/role-based-admin.service";

export interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
}

export const ROUTES: RouteInfo[] = [
  { path: "/dashboard", title: "Dashboard", icon: "nc-bank", class: "" },
  { path: "/icons", title: "Icons", icon: "nc-diamond", class: "" },
  { path: "/maps", title: "Maps", icon: "nc-pin-3", class: "" },
  {
    path: "/notifications",
    title: "Notifications",
    icon: "nc-bell-55",
    class: "",
  },
  { path: "/user", title: "User Profile", icon: "nc-single-02", class: "" },
  { path: "/table", title: "Table List", icon: "nc-tile-56", class: "" },
  {
    path: "/typography",
    title: "Typography",
    icon: "nc-caps-small",
    class: "",
  },
  {
    path: "/upgrade",
    title: "Upgrade to PRO",
    icon: "nc-spaceship",
    class: "active-pro",
  },
];

@Component({
  moduleId: module.id,
  selector: "sidebar-cmp",
  templateUrl: "sidebar.component.html",
})
export class SidebarComponent implements OnInit {
  public menuItems: any[];
  allPermissions: any;
  permissionRecords = {};
  userDetails: any;
  showReferral: any = false;
  clientDetails = JSON.parse(localStorage.getItem("client"));
  projectName =
    this.clientDetails && this.clientDetails["projectName"]
      ? this.clientDetails["projectName"]
      : environment.projectName;
  couponFeature = false;
  revenueAnalyticsFeature = false;
  riderEarningsFeature = false;
  payoutRequestsFeature = false;
  manualPayoutFeature = false;
  companyProfileFeature = false;
  fileUploadFeature = false;
  myAccountFeature = false;
  sellerEarningFeature = false;
  importProductFeature = false;
  commission = false;
  faq = false;
  platformConfig = false;
  walletIncentives = false;
  banners = false;
  notification = false;
  paymentSettings = false;
  services: any;
  serviceMenu = false;
  platformConfigs: string[];
  platformConfigData = [];
  platformType: any = [];
  loader = false;
  defaultLogo =
    this.clientDetails && this.clientDetails["logo"]
      ? this.clientDetails["logo"]
      : "/assets/images/marketplaceLogo.png";
  routeUrl = "";
  serviceEnabledFeature = false;
  accountRoleId = "";
  adminEnable = false;
  roleUserEnable = false;
  permissionData: any;
  roleName = "";
  permissions: any = {};
  menuVisibility: any = {};
  cityDashboardDisabled = false;

  constructor(
    public service: PageService,
    public router: Router,
    public roleService: RoleBasedAdminService,
  ) {}

  ngOnInit() {
    const appName = localStorage.getItem("clientName");
    if (environment.referralClients.indexOf(appName) > -1) {
      this.showReferral = true;
    }
    if (localStorage.getItem("permissionData")) {
      this.permissions = JSON.parse(localStorage.getItem("permissionData"));
      console.log(this.permissions);
    }
    if (localStorage.getItem("selectedCityData")) {
      this.cityDashboardDisabled = true;
    }
    if (localStorage.getItem("accountRole")) {
      this.accountRoleId = localStorage.getItem("accountRole");
      if (this.accountRoleId === "ADMIN") {
        localStorage.removeItem("permissionData");
        this.adminEnable = true;
      } else {
        this.getAccessRole();
        console.log("check");
        this.menuVisibility = this.generateMenuVisibility();
        console.log(this.menuVisibility);
        this.roleUserEnable = true;
      }
    }
    this.routeUrl = this.router.url;
    //using localStorage get platformType

    // const platformTypes = JSON.parse(localStorage.getItem("platformTypes"));
    // console.log(platformTypes);
    // this.platformConfigs = platformTypes;
    // console.log(platformTypes);
    // if (!this.platformConfigs.includes("service")) {
    // } else {
    //   this.serviceMenu = true;
    //   console.log(this.serviceMenu);
    // }

    if (environment.features && environment.features["couponNew"]) {
      this.couponFeature = environment.features["couponNew"];
    }
    if (environment.serviceEnabled) {
      this.serviceEnabledFeature = environment.serviceEnabled[appName]
        ? environment.serviceEnabled[appName]
        : false;
    }
    if (environment.features) {
      this.revenueAnalyticsFeature =
        environment.features["revenueAnalyticsNew"];
      this.riderEarningsFeature = environment.features["riderEarningsNew"];
      this.payoutRequestsFeature = environment.features["payoutRequestsNew"];
      this.manualPayoutFeature = environment.features["manualPayoutNew"];
      this.companyProfileFeature = environment.features["companyProfileNew"];
      this.fileUploadFeature = environment.features["fileUploadNew"];
      this.myAccountFeature = environment.features["myAccountNew"];
      this.sellerEarningFeature = environment.features["sellerEarningsNew"];
      this.importProductFeature = environment.features["importProductsNew"];
      this.commission = environment.features["commission"];
      this.faq = environment.features["faq"];
      this.platformConfig = environment.features["platformConfigNew"];
      this.walletIncentives = environment.features["walletIncentives"];
      this.banners = environment.features["banners"];
      this.notification = environment.features["notification"];
      this.paymentSettings = environment.paymentSettings;
    }

    $(document).on("click", ".sideMenuOption", function () {
      if ($(document).innerWidth() <= 768) {
        $(".sidebar-toggler").addClass("clicked");
        $(".sidebar").addClass("hideme");
        $(".main-panel").addClass("w-100");
        $(".sidebar-toggler").removeClass("clicked");
      }
    });

    this.menuItems = ROUTES.filter((menuItem) => menuItem);

    try {
      this.userDetails = JSON.parse(localStorage.getItem("userDetails"));
    } catch (err) {}

    this.getPlatformConfig();
  }

  // Hide sidebar menus for admin user role

  generateMenuVisibility(): any {
    console.log("check");
    console.log(this.permissions);
    const visibility = {};
    for (const key in this.permissions) {
      if (this.permissions.hasOwnProperty(key)) {
        visibility[key] = this.canView(key);
      }
    }
    console.log(visibility);
    return visibility;
  }

  canView(menuItem: string): boolean {
    // console.log(menuItem);
    if (this.accountRoleId !== "ADMIN") {
      return this.permissions[menuItem]?.view || false;
    } else {
      return true;
    }
  }

  getAccessRole() {
    const data = {
      roleID: this.accountRoleId,
    };
    this.roleService.getAccessRole(data).then((response) => {
      // console.log(response);
      const role = response["data"]["role"];
      console.log(role.name);
      this.roleName = role.name;
    });
  }

  //using API get platformType

  getPlatformConfig() {
    this.service.getplatformConfig().then((data) => {
      this.platformConfigData = data["Data"];
      // console.log(this.platformConfigData);
      if (data["Data"] && data["Data"]["platformType"]) {
        this.platformType = data["Data"]["platformType"];
      }
      if (!this.platformType.includes("service")) {
      } else {
        this.serviceMenu = true;
        // console.log(this.serviceMenu);
      }
    });
  }
}
